<template>
  <div class="bottom" id="bottomContainer">
    <div class="boottmcontent">
      <div class="logo">
        <img src="../assets/images/Logo_.jpg">
        <span class="title">譯友</span>
      </div>
      <div class="description">
        A concise description of the company & product that wraps.
      </div>
      <div class="description inc">
        © 2020 Yiyo Inc.
      </div>
      <div class="productlinklist">
        <ul>
          <li class="fatherli">PRODUCT</li>
          <li @click="changePage('1','1-1')">Features</li>
          <li @click="changePage('3',)">Pricing</li>
          <li @click="changePage('1','1-2')">Download</li>
        </ul>
      </div>
      <div class="solutionslinklist">
        <ul>
          <li class="fatherli">SOLUTIONS</li>
          <li @click="changePage('2','2-1')">For Translators</li>
          <li @click="changePage('2','2-2')">For Teams</li>
          <li @click="changePage('2','2-3')">For Enterprises</li>
        </ul>
      </div>
      <div class="companylinklist">
        <ul>
          <li class="fatherli">COMPANY</li>
          <li @click="changePage('4',)">About</li>
          <li>Careers</li>
        </ul>
      </div>
      <div class="resourceslinklist">
        <ul>
          <li class="fatherli">RESOURCES</li>
          <li @click="changePage('5','5-1')">Support</li>
          <li @click="changePage('5','5-2')">FAQs</li>
          <li @click="changePage('5','5-3')">Contact us</li>
          <li @click="changePage('5','5-4')">Trust & Security</li>
        </ul>
      </div>
    </div>
    <div class="smallbottomcontent">
      <el-menu default-active="3" ref="elMenu" :default-openeds="openList" class="el-menu-demo" mode="vertical"  @select="handleSelect" unique-opened="true">
        <el-submenu index="1">
          <template slot="title" >PRODUCT</template>
          <el-menu-item index="1-1" @click="changePage('1','1-1')">Features</el-menu-item>
          <el-menu-item index="1-2" @click="changePage('3',)">Pricing</el-menu-item>
          <el-menu-item index="1-3" @click="changePage('1','1-2')">Download</el-menu-item>
        </el-submenu>
        <el-submenu index="2">
          <template slot="title">SOLUTIONS</template>
          <el-menu-item index="2-1" @click="changePage('2','2-1')">For Translators</el-menu-item>
          <el-menu-item index="2-2" @click="changePage('2','2-2')">For Teams</el-menu-item>
          <el-menu-item index="2-3" @click="changePage('2','2-3')">For Enterprises</el-menu-item>
        </el-submenu>
        <el-submenu index="3">
          <template slot="title">COMPANY</template>
          <el-menu-item index="3-1" @click="changePage('4',)">About</el-menu-item>
        </el-submenu>
        <el-submenu index="4">
          <template slot="title">RESOURCES</template>
          <el-menu-item index="4-1" @click="changePage('5','5-1')">Support</el-menu-item>
          <el-menu-item index="4-2" @click="changePage('5','5-2')">FAQs</el-menu-item>
          <el-menu-item index="4-3" @click="changePage('5','5-3')">Contact us</el-menu-item>
          <el-menu-item index="4-4" @click="changePage('5','5-4')">Trust & Security</el-menu-item>
        </el-submenu>
      </el-menu>
    </div>
      
  </div>
</template>

<script>
import {mapState,mapMutations} from 'vuex'
export default {
  name: 'top',
  data () {
    return {
      msg: '',
      lang:'zh-CN',
      openList:[],
    }
  },
  mounted: function () {
    this.$nextTick(function () {
      
    })
  },
  computed: {
    
  },
  methods: {
    ...mapMutations(['setMenuPath','setMenuPathKeys','setMenuClickParam','setEmail']),
    changePage(key,keySub){
      // this.$router.push('/Download');

      //console.log(event.$parent,event.$parent.$el,event.$parent.$el.children,key,keySub)
      //event.$parent.$el.children[1].hidden = true;
      this.openList=[];

      this.setMenuPathKeys([key,keySub]);
      this.setMenuClickParam( key + ',' + Math.random());
    },
    handleSelect(){},
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.bottom .boottmcontent{position: relative;width: 100%;height: 460px;color: #FFFFFF;background: #222222;}
.bottom .logo{position: absolute;width: 256.64px;height: 136px;left: 59.92px;top: 100px;}
.bottom .logo img{position: absolute;left: 0;width:32px;height:48px;}
.bottom .logo .title{color: #FFFFFF;position: absolute;left: 44px;top:7px;font-style: normal;font-weight: 200;font-size: 24px;line-height: 34px;text-align: center;}
.bottom .description{ position: absolute; left: 60px; top:164px; font-family: Montserrat; font-style: normal; font-weight: normal; font-size: 14px; line-height: 17px; letter-spacing: 0.02em; color: #FFFFFF; width:257px; text-align: left;}
.bottom .description.inc{
  left: 60px;
  top:219px;
}
.bottom .boottmcontent .productlinklist{
  position: absolute;
  left: 42.7%;
  right: 51.17%;
  top: 21.96%;
  bottom: 52.17%;
}
.bottom .boottmcontent .fatherli{
  font-family: Montserrat;
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;
  letter-spacing: 0.02em;
  margin-top:0px;
}
.bottom .boottmcontent li{
  font-family: Montserrat;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 17px;
  letter-spacing: 0.02em;
  margin-top:21px;
  color:#D3DCE6;
}
.bottom .boottmcontent .fatherli:hover{color:#D3DCE6;cursor:text;}
.bottom .boottmcontent li:hover{color:#FFFFFF;cursor:pointer;}
.bottom .boottmcontent .solutionslinklist{
  position: absolute;
  left: 56.68%;
  right: 35.58%;
  top: 21.96%;
  bottom: 52.83%;
}
.bottom .boottmcontent .companylinklist{
  position: absolute;
  left: 70.42%;
  right: 23.44%;
  top: 21.74%;
  bottom: 60.22%;
}
.bottom .boottmcontent .resourceslinklist{
  position: absolute;
  left: 81.99%;
  right: 6.94%;
  top: 21.96%;
  bottom: 48.26%;
}
.bottom .smallbottomcontent{
  display: none;
  width: 100%;
  height: auto;
}
 /*.bottom .smallbottomcontent .el-submenu__title{
    color: #D3DCE6 !important;
    text-align: left !important;
    background: #222222;
  }
  .bottom .smallbottomcontent .el-submenu .el-menu-item{
    color: #D3DCE6 !important;
    text-align: left !important;
    background: #222222;
  }
  .bottom .smallbottomcontent .el-submenu__title:focus{
    background-color: #222222 !important;
    color:#D3DCE6 !important;
    background: #222222;
    cursor:text;
  }
  .bottom .smallbottomcontent .el-submenu__title:hover{
    background-color: #222222 !important;
    color:#D3DCE6 !important;
    background: #222222;
    cursor:text;
  }
  .bottom .smallbottomcontent .el-menu-item:hover{
    background-color: #222222 !important;
    color:#FFFFFF !important;
    cursor:pointer;
  }
  .bottom .smallbottomcontent .el-menu-item:focus{
    background-color: #222222 !important;
    color:#FFFFFF !important;
    cursor:pointer;
  }*/
@media only screen and (max-width: 825px){
  .bottom .boottmcontent{
    display: none !important;
  }
  .bottom .smallbottomcontent{
    display: inline-block !important;
  }
  .bottom .smallbottomcontent .el-menu{
    border-right: none;
    width: 90%;
    margin: 0 auto;
    background: #222222;
  }
  .bottom .smallbottomcontent{
    background: #222222;
  }
  .bottom .smallbottomcontent .el-submenu__title{
    color: #D3DCE6 !important;
    text-align: left !important;
    background: #222222 !important;
  }
  .bottom .smallbottomcontent .el-submenu .el-menu-item{
    color: #D3DCE6 !important;
    text-align: left !important;
    background: #222222;
  }
 .bottom .smallbottomcontent .el-submenu__title:focus{
    background-color: rgba(34, 34, 34, 1) !important;
    color:#D3DCE6 !important;
   /* background: #222222;
    opacity:0.5;*/
    cursor:text;
  }
 .bottom .smallbottomcontent .el-submenu__title:hover{
    background-color: rgba(34, 34, 34, 1) !important;
    color:#D3DCE6 !important;
    /*background: #222222;
    opacity :0.5;*/
    cursor:text;
  }
  .bottom .smallbottomcontent .el-menu-item:hover{
    background-color: rgba(34, 34, 34, 0.2) !important;
    color:#FFFFFF !important;
    cursor:pointer;
    opacity:0.5;
  }
  .bottom .smallbottomcontent .el-menu-item:focus{
    background-color: rgba(34, 34, 34, 0.2) !important;
    color:#FFFFFF !important;
    cursor:pointer;
    opacity:0.5;
  }
}
</style>




// WEBPACK FOOTER //
// src/components/Bottom.vue